// extracted by mini-css-extract-plugin
module.exports = {"container":"_1VrGcRgzpIM5yac73P_wO-"};